/**
 * 对树形数据进行转换，以满足antd的使用要求
 */

/**
 * 对后台传过来的树型数据进行处理，用于满足easyui的显示需要
 * @param node
 * @returns
 */
const treeDataConversion = (node, nonLeafDisabled) => {
    if (node == null) return null;
    treeLoop(node, nonLeafDisabled);
}

//递归方式处理数据
// const treeRecursion = (tree) => {
//     if(tree != null && tree.length > 0 ){
//         for(let i=0;i<tree.length;i++){
//             tree[i].children = tree[i].subNode;
//             tree[i].title = tree[i].name;
//             tree[i].value = tree[i].code;
//             delete tree[i].subNode;
//             treeRecursion(tree[i].children);
//         }
//     }
// }

//使用非递归方式处理树型数据
const treeLoop = (tree, nonLeafDisabled) => {
    var stack = [];
    stack = stack.concat(tree);
    while (stack != null && stack.length > 0) {
        let node = stack[0];
        stack.splice(0, 1);
        if (node.subNode != null) {
            stack = stack.concat(node.subNode);
        }
        if (nonLeafDisabled === true) {
            node.disabled = (node.subNode != null && node.subNode.length > 0);
        }
        //处理数据
        node.children = node.subNode;
        node.title = node.name;
        node.value = node.code;
        delete node.subNode;
    }
}

/**
 * 将数组结构的数据，转成树形结构的数据
 * @param treeList 数组结构的数据 
 */
const buildTree = (treeList) => {
    if (treeList == null || treeList.length === 0) {
        return treeList;
    }
    let trees = getRootNode(treeList);
    trees = trees.map(node => {
        node.level = 0;
        return node;
    });
    let parentNodes = trees;
    let subNodes = [];
    let level = 1;
    do {
        let treeListTemp = [];
        let codes = parentNodes.map(node => node["code"]);
        treeList.forEach(node => {
            if (!codes.includes(node["code"])) {
                treeListTemp.push(node);
            }
        });
        treeList = treeListTemp;
        subNodes = getRootNode(treeList);
        if (subNodes != null && subNodes.length > 0) {
            // eslint-disable-next-line no-loop-func
            subNodes.forEach(subNode => {
                subNode["level"] = level;
                parentNodes.forEach(parentNode => {
                    if (parentNode["code"] === subNode["parentCode"]) {
                        let list = parentNode["subNode"];
                        if (list == null) {
                            list = [];
                            parentNode["subNode"] = list;
                        }
                        list.push(subNode);
                    }
                });
            });
        }
        parentNodes = subNodes;
        level++;
    } while (subNodes != null);
    return trees;
}

const getRootNode = (treeList) => {
    if (treeList == null || treeList.length === 0) {
        return null;
    }
    let codes = treeList.map(node => node["code"]);
    let trees = [];
    treeList.forEach(node => {
        if (node["parentCode"] == null || node["parentCode"] === '' || !codes.includes(node["parentCode"]) || node["code"] === node["parentCode"]) {
            trees.push(node);
        }
    });
    return trees;
}

export { treeDataConversion, buildTree };